module.exports = {
      id: "android-usage",
      viewBox: "0 0 114 35",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#android",
      toString: function () {
        return this.url;
      }
    }